/* eslint-disable */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import { LOCALSTORAGE_AUTH_KEY, URL_SERVICE_LOGIN } from '../../constants/index';

import s from './LeftNavigationButton.css';

class LeftNavigationButton extends React.Component {
  constructor(props) {
    super(props);
  }
  style() {
    const background = this.props.background;
    return { backgroundImage: `url(${background})` };
  }

  render() {
    return (
      <li className={s.datosIco}>
        <a
          href={this.props.href}
          target="_self"
          data-toggle="tooltip"
          data-placement="right"
          title={this.props.title}
          style={this.style()}
        >
          &nbsp;
        </a>
      </li>
    );
  }
}

export default withStyles(s)(LeftNavigationButton);

LeftNavigationButton.propTypes = {
  background: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/LeftNavigationButton/LeftNavigationButton.js